import React, { useState, useEffect, useRef } from "react";

import styles from "./slider.module.scss";

const ScrollSlider = ({ was, became }) => {
  const targetRef = useRef(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setIsInView(entry.isIntersecting);
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0, // Срабатывание, когда любая часть элемента видна
      }
    );

    const target = targetRef.current;
    if (target) {
      observer.observe(target);
    }

    return () => {
      if (target) {
        observer.unobserve(target);
      }
    };
  }, []);

  return (
    <div className={styles.ScrollSlider}>
      <img
        src={`${was.imageUrl}`}
        alt={was.alt}
        className={styles.ScrollSlider__was}
      />

      <img
        src={`${became.imageUrl}`}
        alt={became.alt}
        className={styles.ScrollSlider__became}
        style={{
            opacity: isInView ? 1 : 0
        }}
      />

      <div ref={targetRef} className={styles.ScrollSlider__hack}></div>
    </div>
  );
};

export default ScrollSlider;
